





















import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Button } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import sharesdk from "@/components/wechat/wechatShareMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    DemoBlock,
    DemoSection,
  },
})
export default class DemoSharePage extends mixins(WeMixin, Jssdk, sharesdk) {
  protected created() {
    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        debug: wjs.debug, // wjs.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
        ], // 必填，需要使用的JS接口列表
      });
      this.$wx.ready(() => {
        this.share1();
        this.share2();
        // this.share1willDeprecated();
        // this.share2willDeprecated();
      });
    });
  }

  private share1() {
    const myimgUrl: string = this.baseUrl() + require("@/assets/logo.png");
    this.$wx.updateAppMessageShareData({
      title: "分享标题", // 分享标题
      desc: "分享描述", // 分享描述
      link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: myimgUrl, // 分享图标
      success: () => {
        // 设置成功
        this.$dialog.alert({ message: "设置成功:" + myimgUrl });
      },
    });
  }

  private share2() {
    const data = this.suggestShareData();
    this.$wx.updateTimelineShareData(
      Object.assign(data, {
        desc: "分享描述2", // 分享描述
        success: () => {
          // 设置成功
          this.$dialog.alert({ message: "设置成功2:" + data.imgUrl });
        },
      })
    );
  }

  /**
   * 即将废弃 请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、updateTimelineShareData 接口。
   */
  private share1willDeprecated() {
    const myimgUrl: string = this.baseUrl() + require("@/assets/logo.png");
    this.$wx.onMenuShareAppMessage({
      title: "分享标题", // 分享标题
      desc: "分享描述", // 分享描述
      link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: myimgUrl, // 分享图标
      success: () => {
        // 用户点击了分享后执行的回调函数
        this.$dialog.alert({ message: "分享成功1" });
      },
    });
  }

  /**
   * 即将废弃 请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、updateTimelineShareData 接口。
   */
  private share2willDeprecated() {
    const data = this.suggestShareData();
    this.$wx.onMenuShareTimeline(
      Object.assign(data, {
        desc: "分享描述2", // 分享描述
        success: () => {
          // 用户点击了分享后执行的回调函数
          this.$dialog.alert({ message: "分享成功2" });
        },
      })
    );
  }
}
